import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_FIELD_CREATE,
  CONTRACT_SETUP_FIELD_REMOVE,
  CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE,
} from '@app/store/actionTypes';
import {
  ContractSetupAction,
  contractSetupSetParticipants,
} from '@app/store/contract-setup/actions';

export interface ContractSetupParticipantsFieldIdsState {
  [participantId: string]: string[];
}

const initialState: ContractSetupParticipantsFieldIdsState = {};

// TODO(@DevSDK): 추후 사용되지 않는 상태인지 확인할 때 살펴보기
const reducer = produce(
  (draft: Draft<ContractSetupParticipantsFieldIdsState>, action: ContractSetupAction) => {
    switch (action.type) {
      case CONTRACT_SETUP_ALL_STATE_CLEAR:
      case CONTRACT_SETUP_BY_DRAFT_REQUEST:
      case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST:
        return initialState;
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST: {
        Object.keys(draft).forEach((participantId) => {
          draft[participantId] = [];
        });
        return draft;
      }
      case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
        const { participantFields } = action.payload;
        participantFields.forEach((participantField) => {
          const { fieldId, participantId } = participantField;
          draft[participantId].push(fieldId);
        });
        return draft;
      }
      case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS: {
        const { participants } = action.payload;
        participants.forEach((participant) => {
          const { participantId } = participant;
          draft[participantId] = [];
        });
        return draft;
      }
      case contractSetupSetParticipants.type: {
        action.payload.forEach(({ participantId }) => {
          draft[participantId] = draft[participantId] ?? [];
        });

        return draft;
      }
      case CONTRACT_SETUP_FIELD_CREATE: {
        const { participantId, uuid } = action.payload.meta;
        draft[participantId].push(uuid);
        return draft;
      }
      case CONTRACT_SETUP_FIELD_REMOVE: {
        const { participantId, uuid } = action.payload;
        if (draft[participantId].includes(uuid)) {
          draft[participantId].splice(draft[participantId].indexOf(uuid), 1);
        }
        return draft;
      }

      case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
        const { participants } = action.payload;

        participants.forEach((participant) => {
          const { fields, id } = participant;

          if (!(id in draft)) {
            draft[id] = [];
          }

          fields.forEach((field) => {
            draft[id].push(field.id);
          });
        });

        return draft;
      }
      case CONTRACT_SETUP_FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE: {
        const { fieldIds } = action.payload;
        const participantIds = Object.keys(draft);
        participantIds.forEach((participantId) => {
          fieldIds.forEach((fieldId) => {
            const index = draft[participantId].findIndex((v) => v === fieldId);
            if (index !== -1) {
              draft[participantId].splice(index, 1);
            }
          });
        });
        return draft;
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
